import React from 'react'

export default function Terms() {
    return (
        <>

            <div className="terms">
                <h1>ĐIỀU KHOẢN SỬ DỤNG</h1>
                Khi sử dụng Website này có nghĩa là bạn đã chấp nhận và đồng ý tuân theo bản Điều khoản sử dụng này, trong trường hợp không đồng ý với những điều khoản này, xin vui lòng không tiếp tục sử dụng Website.

                <h3>1. Website và tác giả</h3>
                Website này là cửa hàng bán game trên Internet và được tác giả cho phép sử dụng để mua sản phẩm.

                <h3>2. Sử dụng hợp pháp</h3>
                Bạn phải chấp nhận rằng bạn sẽ không được phép có bất cứ hành vi nào có thể hiểu rằng bạn đã, đang hoặc sẽ tổ chức kinh doanh bằng Website này dưới bất kỳ hình thức có nội dung vi phạm pháp luật hiện hành và thuần phong mỹ tục Việt Nam; bạn không được tham gia vào bất cứ hoạt động nào liên quan đến việc sử dụng Website thay cho mục đích mua sản phẩm.

                <h3>3. Sự truy cập</h3>
                Tác giả dùng uy tín và năng lực của cá nhân để nỗ lực hết sức mình nhằm bảo đảm sự an toàn cho tất cả người dùng khi những dịch vụ web của anh ta trong mọi trường hợp lây nhiễm virus, đánh cắp thông tin cá nhân, hay bất cứ nguy cơ nào có khả năng gây ra thiệt hại cho người sử dụng.<br />
                Những dịch vụ web này được tác giả xây dựng dựa trên năng lực, tài chính, thời gian, và ý tưởng của cá nhân. Anh ta có toàn quyền định đoạt số phận của mọi thông tin trong những dịch vụ web của mình, nghĩa là anh ta có quyền xóa, sửa, thêm, bớt, thay đổi nội dung bất cứ thông tin nào trong những dịch vụ web đó vào bất cứ thời điểm nào mà anh ta cảm thấy thích hợp.

                <h3>4. Vấn đề bản quyền</h3>
                Tác giả PHẢN ĐỐI bất cứ hành động nào bao gồm việc cố tình cắt ghép, sửa đổi, cấu trúc câu chữ nguyên thủy… mà không được sự đồng ý bằng văn bản, email của anh ta, anh ta từ chối nhận trách nhiệm đối với những hệ quả có thể xảy ra bởi các hành động này.

                Tác giả KHÔNG chấp nhận bất kỳ hình thức đăng tải lại, trích dẫn, cắt ghép một phần hay toàn bộ nội dung để đăng lại ở một nơi khác mà không được sự đồng ý bằng văn bản hay email của anh ta.

                Tất cả hình ảnh, biểu tượng, và tất cả các nội dung khác tại Website này thuộc sở hữu của tác giả, chúng tôi cho phép bạn xem, sử dụng Website:
                <br />
                – Không sử dụng cho mục đích thương mại.
                <br />
                – Không chỉnh sửa, can thiệp vào sự điều hành Website.
                <br />
                – Lợi dụng lỗ hổng để đánh cắp thông tin, dữ liệu.
                <br />

                <h3>Mọi thắc mắc, yêu cầu chỉnh sửa, sử dụng quyền quản trị Website phải liên hệ với tác giả qua:</h3>
                + <a target="_blank" rel="noreferrer" href="https://www.facebook.com/solitude2510/">Facebook</a>
                <br />
                + <a target="_blank" rel="noreferrer" href="https://www.instagram.com/tuannhat._/">Instagram</a>
                <br />
                + <a target="_blank" rel="noreferrer" href="mailto:tuannhat1209@gmail.com">Email</a>
            </div>
        </>
    )
}